import { buildConfigValidator } from '@shared/lib/schema';
import * as yup from 'yup';

const configSchema = {
  allowMultiple: yup.bool().required(),
  contactLabel: yup.string(),
  label: yup.string().min(3).required(),
  description: yup.string(),
  steps: yup
    .array()
    .of(yup.object())
    .test('is-active', 'At least one step is not active', (value, context) =>
      value?.some((step) => step.config?.active)
    )
    .required(),
};

const isConfigValid = buildConfigValidator(configSchema);

export const StepAdditionalContact = {};

StepAdditionalContact.isConfigValid = isConfigValid;
